export default __webpack_public_path__ + "static/media/cigar3.0b8c799b.jpg";